import React from 'react';
import { ReferenceImageSlide } from './ReferenceImageSlide';
import type { SlideProps } from './SlideShell';
export function SlideReferenceEveryChannel(props: SlideProps) {
  return <ReferenceImageSlide {...props} src="https://cdn.magicpatterns.com/uploads/4zBBtHke48GQNoVan3rUp8/Screenshot_2026-08-21_at_10.37.03.png" alt="One campaign, every relevant channel" recolorOrange data-id="element-181" data-mp="264q21vssuqag" />;
}